import React, { useEffect, useRef } from 'react';
import { Drawer } from '@gjensidige/core-drawer';
import { Text, Title } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import { CheckListItem } from '../../types';
import { PrimaryButton } from '../Button';
import TextContainer from '../TextContainer';
import styles from './Modal.module.scss';

interface ModalProps {
  visible: boolean;
  toggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  checkListItem: CheckListItem;
}

const Modal = ({
  visible,
  toggle,
  checkListItem: { texts, imageSrc, link }
}: ModalProps) => {
  const { getText } = useCmsContext();
  const modalContent = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (visible) {
      modalContent.current?.scrollIntoView();
    }
  }, [visible]);

  return (
    <Drawer
      ariaLabel=""
      backdrop
      closable
      visible={visible}
      onClick={toggle}
      contentClassName={styles.content}
      className={styles.drawer}
    >
      <div data-testid="drawerContent" ref={modalContent}>
        <Title tag="h1" size="h3">
          {getText(`${texts}.modal.title`)}
        </Title>
        <img className={styles.image} src={imageSrc} alt="modal-img" />
        <Text className={styles.text} size="lead">
          {getText(`${texts}.modal.text`)}
        </Text>

        <Title tag="h2" size="h4">
          {getText('housing.check.common.where')}
        </Title>
        <Text className={styles.text}>{getText(`${texts}.modal.where`)}</Text>

        <Title tag="h2" size="h4">
          {getText('housing.check.common.how')}
        </Title>
        <Text className={styles.text}>{getText(`${texts}.modal.how`)}</Text>

        <Title tag="h2" size="h4">
          {getText('housing.check.common.why')}
        </Title>
        <Text>{getText(`${texts}.modal.why`)}</Text>

        {link !== undefined && (
          <a
            className={styles.link}
            href={link.href}
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </a>
        )}

        <TextContainer className={styles.textContainer}>
          <Title tag="h1" size="h3">
            {getText('housing.check.common.howOften')}
          </Title>
          <Text>{getText(`${texts}.modal.howOften`)}</Text>
        </TextContainer>

        <PrimaryButton className={styles.button} onClick={toggle}>
          {getText('housing.check.common.close')}
        </PrimaryButton>
      </div>
    </Drawer>
  );
};

export default Modal;
